import BUILD_INFO, {
  APP_VERSION,
  BUILD_GENERATED_AT,
  BUILD_GIT_SHA,
  BUILD_ID,
  BUILD_LABEL,
  BUILD_SOURCE
} from './generated/buildInfo';

if (typeof window !== 'undefined') {
  window.__ITRAXX_BUILD_INFO__ = BUILD_INFO;
}

export default BUILD_INFO;
export {
  APP_VERSION,
  BUILD_GENERATED_AT,
  BUILD_GIT_SHA,
  BUILD_ID,
  BUILD_LABEL,
  BUILD_SOURCE
};
